import { app } from "../config/firebase";
import { getAuth } from "firebase/auth";

// const HELLORADIUS_SERVER_API = "http://localhost:8080";
// const HELLORADIUS_SERVER_API =
// window.origin === "http://localhost:3000"
//   ? "http://localhost:8080"
//   : process.env.REACT_APP_HELLORADIUS_SERVER;
const HELLORADIUS_SERVER_API = process.env.REACT_APP_HELLORADIUS_SERVER;
export const COMPLETE_SIGNUP_ENDPOINT = `${HELLORADIUS_SERVER_API}/complete-sign-up`;
export const SEND_VERIFICATION_EMAIL_ENDPOINT = `${HELLORADIUS_SERVER_API}/send-verification-email`;
export const SEND_PASSWORD_RESET_EMAIL_ENDPOINT = `${HELLORADIUS_SERVER_API}/send-password-rest-email`;
export const NOTIFY_ADMINS_ENDPOINT = `${HELLORADIUS_SERVER_API}/notify-admins`;
export const CANDIDATE_SUGGESTIONS_ENDPOINT = `${HELLORADIUS_SERVER_API}/candidate-suggestions`;
export const CREATE_INVOICE_ENDPOINT = `${HELLORADIUS_SERVER_API}/create-payment-invoice`;
export const CREATE_PAYMENT_INTENT_ENDPOINT = `${HELLORADIUS_SERVER_API}/create-payment-intent`;
export const CREATE_CHECKOUT_SESSION_ENDPOINT = `${HELLORADIUS_SERVER_API}/create-checkout-session`;
export const CREATE_CUSTOMER_PORTAL_ENDPOINT = `${HELLORADIUS_SERVER_API}/create-customer-portal-session`;
export const VALIDATE_STRIPE_CUSTOMER_ENDPOINT = `${HELLORADIUS_SERVER_API}/validate-stripe-customer`;
export const UPDATE_STRIPE_CUSTOMER_ENDPOINT = `${HELLORADIUS_SERVER_API}/update-stripe-customer`;
export const UPDATE_SUBSCRIPTION_METADATA_ENDPOINT = `${HELLORADIUS_SERVER_API}/update-subscription-metadata`;
export const UPDATE_STRIPE_CUSTOMER_TAX_ENDPOINT = `${HELLORADIUS_SERVER_API}/update-stripe-customer-tax-details`;
export const CUSTOMER_DETAILS_ENDPOINT = `${HELLORADIUS_SERVER_API}/customer-details`;
export const CUSTOMER_TAX_DETAILS_ENDPOINT = `${HELLORADIUS_SERVER_API}/customer-tax-details`;
export const INVOICES_ENDPOINT = `${HELLORADIUS_SERVER_API}/invoices`;
export const GET_INVOICE_DETAILS_ENDPOINT = `${HELLORADIUS_SERVER_API}/get-invoice-details`;
export const DELETE_USER_ENDPOINT = `${HELLORADIUS_SERVER_API}/delete-user`;
export const ADMIN_REVIEW_ENDPOINT = `${HELLORADIUS_SERVER_API}/review-service`;
export const ADMIN_CLOSE_ENDPOINT = `${HELLORADIUS_SERVER_API}/close-service`;
export const WORKER_TASK_ENDPOINT = `${HELLORADIUS_SERVER_API}/worker-task`;
export const GET_AUTH_DETAILS_ENDPOINT = `${HELLORADIUS_SERVER_API}/user-auth-details`;
export const MANAGE_AUTH = `${HELLORADIUS_SERVER_API}/manage-auth`;

const auth = getAuth(app);

export const API_CONSTANTS = {
  worker: {
    updateMultipleLocJobs: "UPDATE_MULTIPLE_LOC_JOBS",
  },
};

export async function callAPI({
  endpoint,
  httpMethod = "POST",
  isAuthToken = true,
  opts,
}) {
  const { method, body } = { method: httpMethod, body: null, ...opts };
  const user = auth.currentUser;

  const token = user && (await user.getIdToken());

  const res = await fetch(endpoint, {
    method,
    ...(body && { body: JSON.stringify(body) }),
    headers: {
      "Content-Type": "application/json",
      ...(isAuthToken && token && { Authorization: `Bearer ${token}` }),
    },
  });

  if (res.status === 200) {
    return res.json();
  } else {
    throw new Error(res.statusText);
    // return new Error(res.statusText);
  }
}

export function getSignupInfo({ currentUserAccount }) {
  return {
    email: currentUserAccount.email,
    firstName: currentUserAccount.firstName,
    lastName: currentUserAccount.lastName,
    phone: currentUserAccount.phoneNumber,
    userId: currentUserAccount.id,
    type: currentUserAccount.type,
    countryCode: currentUserAccount.countryCode,
    company: currentUserAccount.isEmployer ? currentUserAccount.company : "",
    currencyCode: currentUserAccount.isEmployer
      ? currentUserAccount.currencyCode
      : "",
    isSignupWithMarketing: currentUserAccount.isSignupWithMarketing || false,
    isEmployer: currentUserAccount.isEmployer,
    mode: currentUserAccount.isEmployer ? currentUserAccount.mode : "",
    timestamp: Date.now().toString(),
  };
}
